export { default } from './TabList';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/TabList/index.js
// module id = 379
// module chunks = 0